import React from "react";

const CompanyProfile = () => {
  return (
    <div>
      <h1>CompanyProfile</h1>
    </div>
  );
};

export default CompanyProfile;
